<div *ngIf="employee$ | async as employee" class="container-fluid container-fluid--normal">
  <div class="d-flex mb-4">
    <div class="pt-2 pb-1 mb-3 row m-0 me-5">
      <button class="btn-close me-3" *ngIf="!learningPathId"></button>
      <h2 class="mb-0">
        <b>{{ employee.student.firstName }} {{ employee.student.lastName }}</b>
      </h2>
    </div>
    <div class="learnpath-part col rounded">
      <div class="learnpath-part-name">
        <h2 class="mt-2 fw-normal">{{ employee.learningPath.name }}</h2>
      </div>
      <i
        *ngIf="employee.student.deadline"
        class="fa-bell ms-5 me-3"
        style="line-height: 35px"
        [ngClass]="{
          'fas statusUrgent text': employee.student.deadlineClose,
          far: !employee.student.deadlineClose
        }"
        placement="top right"
        container="body"
        ngbTooltip="{{ 'expirationdate' | label : 'learningpath' | async }}: {{ employee.student.deadline | employeeDate | async }}"
      >
      </i>
      <div class="learnpath-part-activities ms-3 flex-grow-1 align-items-center">
        <button *ngFor="let activity of employee.studentActivities" class="btn d-block w-100 ms-2 flex-grow-1" placement="top" container="body" ngbTooltip="{{ activity.name + ': ' + getActivityStatus(activity.activityStatusId) }}" [ngClass]="getActivityClass(activity)">&nbsp;</button>
      </div>
    </div>
  </div>

  <div class="activity-list">
    <div
      class="border mb-4 ps-3 pe-3 pt-5 pb-3"
      *ngFor="let activity of employee.studentActivities; let i = index"
      [ngClass]="{
        'activity-not-started': activity.activityStatusId === 1,
        'activity-started': activity.activityStatusId === 2,
        'activity-finished': activity.activityStatusId === 3
      }"
    >
      <div class="ms-5">
        <div class="d-flex flex-row">
          <div class="me-5" *ngIf="activity.coursePhotoId">
            <app-circle-image [photo]="activity.coursePhoto" [width]="100"></app-circle-image>
          </div>
          <div class="w-100">
            <h2>
              {{ activity.name }}
            </h2>
            <div class="row">
              <div class="pt-0 ps-0 col-12 col-md-9">
                <p class="mb-1" *ngIf="activity.activityStatusId >= 2">
                  <b>{{ 'started' | label : 'learningpath' | async }}:</b>
                  {{ activity.startDate | employeeDate | async }}
                </p>
                <p class="mb-1" *ngIf="activity.activityStatusId === 3">
                  <b>{{ 'completed' | label : 'learningpath' | async }}:</b>
                  {{ activity.finishedDate | employeeDate | async }}
                </p>

                <div *ngIf="activity.activityStatusId == 2">
                  <div class="mb-3 mt-3" *ngIf="activity.activityTypeId == 1 && activity.course">
                    <div *ngIf="activity.course.registered">
                      {{ employee.student.firstName }}
                      {{ 'is_registered_for_the_course' | label : 'learnpathEssDetail' | async }}
                      <b>"{{ activity.course.courseName }}"</b>
                      {{ 'on' | label : 'learnpathEssDetail' | async }}
                      <b>{{ activity.course.startDate | employeeDate | async }}</b
                      >.
                    </div>

                    <div *ngIf="!activity.course.registered && activity.course.requested">
                      {{ activity.course.requestedBy }}
                      {{ 'has_registered_for_the_course' | label : 'learnpathEssDetail' | async }}
                      <b>"{{ activity.course.courseName }}"</b>
                      {{ 'you_have_registered_for_the_course_part2' | label : 'learnpathEssDetail' | async }}
                      <b>{{ activity.course.dateRequested | employeeDate | async }}</b
                      >.
                    </div>

                    <!-- <pre class="mt-5">{{ activeActivity.course | json }}</pre> -->
                  </div>
                </div>

                <p class="mb-0">
                  <b>{{ 'employeecomments' | label : 'learningpath' | async }}:</b>
                </p>
                <blockquote class="blockquote me-4">
                  <p class="mb-1">
                    {{ activity.studentComment && activity.studentComment.length > 0 ? activity.studentComment : '/' }}
                  </p>
                </blockquote>
              </div>
              <div class="mb-3 col-12 col-md-3">
                <label for="'selectStatus' + i"
                  ><b>{{ 'detail_status' | label : 'learningpath' | async }}: </b></label
                >
                <select class="form-control cursor-pointer" [id]="'selectStatus' + i" [(ngModel)]="activity.activityStatusId" (change)="requestChangeStatus($event, employee.student.learningPathStudentId, activity.studentActivityId, activity.activityStatusId)">
                  <option *ngFor="let status of statusses" [ngValue]="status.learningPathStudentActivityStatusId" [selected]="status.learningPathStudentActivityStatusId === activity.activityStatusId ? 'selected' : ''">
                    {{ status.label }}
                  </option>
                </select>
              </div>
            </div>
            <label
              ><b>{{ 'managercomments' | label : 'learningpath' | async }}:</b></label
            >
            <div class="row">
              <div class="mb-3 col-12 col-md-9 ps-0">
                <textarea [(ngModel)]="activity.managerComment" class="form-control" id="reason" rows="5" placeholder=""></textarea>
              </div>
              <div class="col-12 col-md-3">
                <app-button [blockDisplay]="true" (click)="saveManagerComment(activity)">
                  {{ 'savecomment' | label : 'learningpath' | async }}
                </app-button>
              </div>
            </div>
            <div *ngIf="activity.activityTypeId === 6 && (activity.file$ | async) as files">
              <h5>{{ 'files' | label : 'learningpath' | async }}</h5>
              <p *ngIf="files[0] as file" [appFileLink]="file"><i class="fa fa-paperclip"></i> {{ file.fileName }}</p>
            </div>
            <ul>
              <li *ngFor="let line of getHistory(activity.studentActivityId) | async">{{ line.date | employeeDate : '[SlashDate] HH:mm' | async }}: {{ line.message }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row align-items-center" *ngIf="employee.student.learningPathStudentStatus < 4">
    <div class="mt-4 mb-2 col-sm-10">
      <app-button class="me-1" type="button" (click)="sendReminder(employee.student.learningPathStudentId)">
        {{ 'send_reminder' | label : 'learningpath' | async }}
      </app-button>
      <app-button type="button" class="ms-4" (click)="unsubscribe(employee.student.learningPathStudentId)">
        {{ 'unsubscribe' | label : 'learningpath' | async }}
      </app-button>
    </div>
  </div>
</div>

<ng-template #confirmStatusChange let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      {{ 'changestatus' | label : 'learningpath' | async }}
    </h5>
    <button type="button" class="btn-close no-outline" aria-label="close" (click)="modal.dismiss()"></button>
  </div>
  <div [formGroup]="statusChangeForm" class="modal-body">
    <p>{{ 'changestatusconfirmation' | label : 'learningpath' | async }}</p>
    <div class="mb-3">
      <label for="reason">{{ 'changestatusreason' | label : 'learningpath' | async }}</label>
      <textarea formControlName="message" class="form-control" id="reason" rows="7" [placeholder]="'changestatusreason' | label : 'learningpath' | async"></textarea>
    </div>
    <div class="d-flex flex-row">
      <button type="button" class="btn btn-progreso me-3" (click)="changeStatus()">
        {{ 'confirm' | label : 'learningpath' | async }}
      </button>
      <button type="button" class="btn btn-cancel" (click)="cancelChangeStatus()">
        {{ 'cancel' | label : 'learningpath' | async }}
      </button>
    </div>
  </div>
</ng-template>
